import React, { useEffect, useRef, useState } from "react";
import { TextFieldProps } from "./TextField.props";
import cn from "classnames";
import styles from "./TextField.module.scss";
import useMediaQuery from "../../../utils/hooks/utils";
import { ReactComponent as Calendar } from "../../../assets/icons/Calendar.svg";

export default function TextField({
  placeholder,
  type,
  field,
  className,
  validation = false,
  validRegister,
  autoComplete,
  color,
  disabled = false,
  date = false,
  dateValue,
  setDateValue,
  subscribe = false,
  ...props
}: TextFieldProps): JSX.Element {
  const dateRef = useRef<any>();

  const mob425 = useMediaQuery("max", 500);

  if (field === "input") {
    return (
      <div
        className={cn(styles.input, styles.textField, className, {
          [styles.primary]: color === "primary",
          [styles.warning]:
            validRegister &&
            !subscribe &&
            (validRegister.name === "name" || validRegister.name === "email"),
        })}
      >
        {validation ? (
          <>
            {date ? (
              <>
                <input
                  placeholder={placeholder}
                  type={type}
                  {...validRegister}
                  ref={dateRef}
                  autoComplete={autoComplete}
                  onChange={(e) => setDateValue(e.target.value)}
                  {...props}
                />
                {!!!dateValue && (
                  <span
                    className={styles.datePlaceholder}
                    onFocus={() => dateRef.current && dateRef.current.focus()}
                    onClick={() => dateRef.current && dateRef.current.focus()}
                  >
                    {placeholder}
                  </span>
                )}
                {mob425 && !!!dateValue && (
                  <Calendar
                    className={styles.dateMob}
                    onClick={() => dateRef.current && dateRef.current.focus()}
                  />
                )}
              </>
            ) : (
              <input
                placeholder={placeholder}
                type={type}
                {...validRegister}
                autoComplete={autoComplete}
                {...props}
              />
            )}
          </>
        ) : (
          <input
            placeholder={placeholder}
            type={type}
            autoComplete={autoComplete}
            disabled={disabled}
            defaultValue={"+7"}
            {...props}
          />
        )}
      </div>
    );
  }
  return (
    <div
      className={cn(styles.textarea, styles.textField, className, {
        [styles.primary]: color === "primary",
      })}
    >
      {validation ? (
        <textarea placeholder={placeholder} {...validRegister} {...props} />
      ) : (
        <textarea placeholder={placeholder} {...props} />
      )}
    </div>
  );
}
